import useSWR from 'swr'
import { motion } from 'framer-motion'
import { IconInstagram } from '@/components'
import { fetcher } from '@/libs/utils'
import { INSTAGRAM_URL } from '@/libs/const'
import type { SettingsType } from '@/@types/microcms-type'

type InstagramLinkProps = {
    isOpen: boolean
}

export const InstagramLink = ({ isOpen }: InstagramLinkProps) => {
    const { data: settings, error } = useSWR<SettingsType>(
        '/api/settings',
        fetcher
    )

    if (error) {
        console.error(error)
        return null
    }

    if (!settings) return null

    const INSTAGRAM_LINK = settings.instagram_url ?? INSTAGRAM_URL

    return (
        <motion.p
            initial="hidden"
            animate={isOpen ? 'visible' : 'hidden'}
            variants={{
                hidden: { opacity: 0 },
                visible: {
                    opacity: 1
                }
            }}
            transition={{
                duration: 0.4,
                delay: 0.6
            }}
            className="md:!text-right"
        >
            <a
                href={INSTAGRAM_LINK}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="instagram link"
                className="flex items-center md:justify-end gap-2"
            >
                <IconInstagram />
                <span className="text-v-xs">@tsuzuku_tokyo</span>
            </a>
        </motion.p>
    )
}
